import { CellControllerKind } from '../config';

export enum NumberFormat {
  percent = 'percent',
  default = 'default',
}

export type NumberControllerEntityApi = {
  controller_kind: CellControllerKind.NUMBER;
  controller: {
    value: number;
    format: NumberFormat;
  };
};

export type NumberControllerEntity = {
  controllerKind: CellControllerKind.NUMBER;
  controller: {
    value: number;
    format: NumberFormat;
  };
};
